import React from 'react'
import { motion } from "framer-motion"
import service_bg from "../assets/images/services/services-5.jpg"
import heart from "../assets/images/services/heart.png"
import { getServiceDate, getServiceData } from '../utlits/fackData/classData';
import K12Form from '../components/sections/k12Form'
import PageTitle from '../components/common/pageTitle'
import { ScrollRestoration } from 'react-router-dom'
import { zoomIn } from '../utlits/zoomIn'

const K12Details = () => {
  const k12Date = getServiceDate(4); // Gets k12 details
  const serviceData = getServiceData(4); // Gets complete service data including dates
  
  return (
    <>
      <PageTitle link={"K-12 CPR Details"} pageName={"KK-12 CPR Training Details"} />
      <div className="services-details-area pt-100 pb-75">
        <div className="container">
          <div className="row">
            <div className="col-lg-6">
              <motion.div className="image"
                initial="offscreen"
                whileInView="onscreen"
                variants={zoomIn(1)}
                viewport={{ once: true, amount: 0 }}
              >
                <img src={service_bg} alt="K-12 Cpr Training" />
              </motion.div>
            </div>
            <div className="col-lg-6">
              <h1>K-12 CPR Training</h1>
              <h2>$65 | {k12Date}</h2>
              <br />

              <h3>Woodlawn<br />
              1450 Hwy 98 E Columbia, MS 39429</h3>
              <p>K-12 CPR is specifically designed for students, faculty, and staff.  This is different from coaching requirements to have HeartSaver.</p>
              <p>Learn to save lives with certified American Heart Association medical training for all ages. This comprehensive CPR certification course will teach you the lifesaving skills needed in emergency situations.</p>
            
              <div className="row">
                              <div className="col-lg-6 col-sm-6">
                                <div className="content-item">
                                  
                                  <p>After you complete the form, you will be taken to our payment page. Your payment is required to reserve your seat immediately.
                                  If you have any questions or concerns please contact us at j5solutionssp@gmail.com. You can also call or text (601)633-1159.
                                  We look forward to training with you.</p>
                                </div>
                              </div>
                              <div className="col-lg-6 col-sm-6">
                                <div className="content-item">
                                  <img src={heart} alt="Aligned Instructor" />
                                </div>
                              </div>
                            </div>
            </div>
          </div>
        </div>
        <div className="services-details-area pt-100 pb-75"> 
          <K12Form serviceData={serviceData} />
        </div>
      </div>
      <ScrollRestoration />
    </>
  )
}

export default K12Details